<template>
  <div
    class="flex flex-row items-center p-2 gap-2 h-12 self-stretch bg-white rounded-lg cursor-pointer transition-colors duration-150 hover:bg-[#f2f5f8] focus-visible:bg-[#f2f5f8] focus-visible:outline-none"
    role="menuitem"
    tabindex="0"
  >
    <div class="flex items-center justify-center w-8 h-8 rounded-md shrink-0 bg-transparent">
      <i
        class="pi text-[#325F80] text-base"
        :class="icon"
      />
    </div>
    <div class="flex flex-col justify-center items-start gap-1 flex-1 min-w-0 h-[38px]">
      <span class="w-full font-bold text-base leading-[19px] text-[#2d3032] overflow-hidden text-ellipsis whitespace-nowrap">{{ title }}</span>
      <span
        v-if="subtitle"
        class="w-full font-normal text-sm leading-[17px] text-[#717379] overflow-hidden text-ellipsis whitespace-nowrap"
      >{{ subtitle }}</span>
    </div>
    <div class="flex items-center justify-center w-10 h-10 p-3 shrink-0">
      <i class="pi pi-chevron-right text-[#325F80] text-sm" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProfileMenuItem',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
});
</script>
